
import {ADD_ERRORFIELD} from '../reducers/usrfields.js';
import {REMOVE_ERRORFIELD} from '../reducers/usrfields.js';

export default function updateValidationStatus(action,value){
    switch(action){
        case "add":
            return {
              'type': ADD_ERRORFIELD,
              value
            }
        case "remove":
            return{
                'type': REMOVE_ERRORFIELD,
                value
            }
        default: 
           return
    }
}